<template>
	<div class="pedigreeChartContainer" style="padding-top:50px;">
		<div class="header pedigree-search">
			<div class="srch_type">
				<van-dropdown-menu>
					<van-dropdown-item :title="srchTypeItems[srchType].title" >
						<div class="srch_item">
							<div class="srch_title">类型：</div>
							<div class="srch_option">
								<van-cell-group > 
									<van-radio-group v-model="srchType" direction="horizontal">
										<van-radio :name="key" v-for="(item, key) in srchTypeItems" :key="key" checked-color="#e8441b">{{item.title}}</van-radio>
									</van-radio-group>
								</van-cell-group > 
							</div>
						</div>
						<div class="srch_item" v-if="srchType=='personal'">
							<div class="srch_title">生肖：</div>
							<div class="srch_option">
								<van-checkbox-group v-model="srchTypeItems[srchType].params.chkZodias" direction="horizontal">
									<van-checkbox :name="item.sx" v-for="(item,k) in $parent.scsx" :key="k" shape="square" style="margin:0px 16px 5px 0px;" icon-size="14px">{{item.sx}}</van-checkbox>
								</van-checkbox-group>
							</div>
						</div>
						<div class="srch_item">
							<div class="srch_title">{{srchTypeItems[srchType].dateTitle}}：</div>
							<div class="srch_option">
								<div class="srch_from bord">
									<van-cell title="从" title-class="van-field__label" :value="srchTypeItems[srchType].params.dateBeg" is-link @click="showCanlendar2Query('dateBeg')">
									</van-cell>
								</div>
								<div class="srch_to bord">
									<van-cell title="至" title-class="van-field__label" :value="srchTypeItems[srchType].params.dateEnd" is-link @click="showCanlendar2Query('dateEnd')">
									</van-cell>
								</div>
							</div>
							<div class="srch_option">
								<van-field
									v-model.trim="srchTypeItems[srchType].params.dateStr"
									label=""
									placeholder="其他年代请输入"
									clearable
								></van-field>
							</div>
						</div>
						<div class="srch_item" v-if="srchType=='personal'">
							<div class="srch_title">族内：</div>
							<div class="srch_option">
								<van-radio-group v-model="inLaws" direction="horizontal">
									<van-radio name="-1" icon-size="14px">全部</van-radio>
									<van-radio name="0" icon-size="14px">是</van-radio>
									<van-radio name="1" icon-size="14px">否</van-radio>
								</van-radio-group>
							</div>
						</div>
						<div class="srch_item" v-if="srchType=='personal'">
							<div class="srch_title">健在：</div>
							<div class="srch_option">
								<van-radio-group v-model="health" direction="horizontal">
									<van-radio name="-1" icon-size="14px">全部</van-radio>
									<van-radio name="0" icon-size="14px">是</van-radio>
									<van-radio name="1" icon-size="14px">否</van-radio>
								</van-radio-group>
							</div>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
			<div class="srch_txt">
				<van-search
				  v-model.trim="searchText" 
				  shape="round"
				  show-action
				  :placeholder="srchTypeItems[srchType].placeholder"
				  @search="onSearch"
				>
					<template #left-icon>
					</template>
					<template #action>
						<div class="skin_color" @click="onSearch" style="margin-left:8px;">搜索</div>
					</template>
				</van-search>
			</div>
		</div>

		<div class="pedigree-search">
			<div class="empty" v-if="!srchKeyWord&&srchKeyWord!=''&&dataList.length==0&&!loading">
				<span class="msg">没有查找到与 “ <span class="skin_color">{{srchKeyWord}}</span> ” 相关信息！</span>
			</div>
		
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="dataList.length==0?'暂无数据':'没有更多数据了'"
				@load="getDataList"
				v-if="curSrchType=='personal'"
				>
					<van-swipe-cell
						v-for="(item,ind) in dataList"
						:key="ind">
						<van-card
							:style="'margin-bottom:10px;'"
							:thumb="item.head_img?(item.head_img.indexOf('http')==-1?(attach_url+item.head_img):item.head_img):coverImg[item.sex]"
						>
							<template #title>
								<div style="padding-bottom:5px;">
									<span :style="'font-weight:bold; margin-right:5px;font-size:14px;padding: 2px;'+(item.past_id?'border: 1px solid;':'')">{{(item.surname&&family_name!=item.surname)?item.surname:''}}{{item.name}}</span>
									{{getOrderStr(item.orders, item.sex)}}
								</div>
							</template>
							<template #desc>
								<div style="line-height:18px;padding-bottom:5px;">
									<div v-if="item.live_address"><van-icon name="location-o" />{{item.live_address}}</div>
									<div v-html="getDateStr(item)"></div>
									<div v-if="item.remark">{{item.remark}}</div>
								</div>
							</template>
							<template #num>
								<van-tag type="warning">{{getZodiacStr(item.zodiac,item.birthday)}}</van-tag>
							</template>
							<template #price v-if="item.telphone">
								<div style="line-height:18px;">
									<van-icon name="phone-o" /><a :href="'tel:' + item.telphone" @click.stop="">{{item.telphone}}</a>
								</div>
							</template>
						</van-card>

						<template #right>
							<van-button square text="更多信息" type="primary" @click="onViewPersonal(item.id, item.sex, item.past_id)"/>
						</template>

					</van-swipe-cell>
				</van-list>

				
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="dataList.length==0?'暂无数据':'没有更多数据了'"
				@load="getDataList"
				v-if="curSrchType=='education'"
				>
					<van-card
						v-for="(item,ind) in dataList"
						:key="ind"
						:desc="item.professional||''"
						:thumb="item.head_img?(item.head_img.indexOf('http')==-1?(attach_url+item.head_img):item.head_img):coverImg[item.sex]"
						:style="'margin-bottom:10px;'"
					>
						<template #title>
							<span style="font-weight:bold;">{{item.school}}</span> <span class="skin_color">{{item.education}}</span>
						</template>
						<template #num>
							<span class="skin_color">{{(item.surname&&family_name!=item.surname)?item.surname:''}}{{item.name}}</span>
						</template>
						<template #price>
							{{item.date_edu?item.date_edu:(item.date_start+' 至 '+item.date_end)}}
						</template>
					</van-card>

				</van-list>

				
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="dataList.length==0?'暂无数据':'没有更多数据了'"
				@load="getDataList"
				v-if="curSrchType=='house'"
				>
					<van-card
						v-for="(item,ind) in dataList"
						:key="ind"
						:thumb="item.pic?(item.pic.indexOf('http')==-1?(attach_url+item.pic):item.pic):''"
						:desc="item.remark||''"
						:style="'margin-bottom:10px;'"
						class="pdg-srch-house"
					>
						<template #title>
							<span style="font-weight:bold;">{{item.name}}</span> <span class="skin_color">{{item.direction}}</span>
						</template>
						<template #tags v-if="item.imgs">
							<div :style="{'padding':'5px 2px'}">
								<img :src="attach_url+uri" v-for="(uri,i) in item.imgs.split(',')" :key="i" :style="{height:'30px','margin-right':'5px'}" @click.stop="previewImg(item.imgs, i)"/>
							</div>
						</template>
						<template #price>
							始于 {{item.date_house?item.date_house:item.date_build}} {{item.date_finished?('，结束于 '+item.date_finished):''}}
						</template>
						<template #num>
							<span class="skin_color">{{item.personals}}</span>
							<van-tag plain type="warning">{{houseTypes[item.types-1]}}</van-tag>
						</template>
					</van-card>
				</van-list>

				
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="dataList.length==0?'暂无数据':'没有更多数据了'"
				@load="getDataList"
				v-if="curSrchType=='vitae'"
				>
					<van-card
						v-for="(item,ind) in dataList"
						:key="ind"
						:thumb="item.head_img?(item.head_img.indexOf('http')==-1?(attach_url+item.head_img):item.head_img):coverImg[item.sex]"
						:desc="item.remark||''"
						:style="'margin-bottom:10px;'"
					>
						<template #title>
							<span style="font-weight:bold;">{{item.content}}</span>
						</template>
						<template #num>
							<span class="skin_color">{{(item.surname&&family_name!=item.surname)?item.surname:''}}{{item.name}}</span>
						</template>
						<template #price>
							{{item.date_vitae?item.date_vitae:(item.date_start+' 至 '+item.date_end)}}
						</template>
					</van-card>

				</van-list>

			</van-pull-refresh>

			

		</div>
		<van-popup v-model="showPersonalPopup" position="bottom" closeable close-icon="close" :style="{ 'height': (winH-100)+'px','bottom':'50px','padding-top': '30px','box-sizing': 'border-box'}">
			<van-tabs v-model="personalActive" sticky v-if="showPersonalPopup">
				<van-tab title="个人信息">
					<personal-info :readonly="true" :info="personalInfo" :relation="{}" :pasted.sync="showPastTab" :families="$parent.familyNameIndex" :scsx="$parent.scsx"></personal-info>
				</van-tab>
				<van-tab title="教育"">
					<edu :readonly="true" :p_id="actionPsrId" ></edu>
				</van-tab>
				<van-tab title="置业">
					<house :readonly="true" :p_id="actionPsrId" :pdg_p_id="personal_id"></house>
				</van-tab>
				<van-tab title="履历">
					<vitae :readonly="true" :p_id="actionPsrId" ></vitae>
				</van-tab>
				<van-tab title="账务记录">
					<finance :readonly="true" :fid="actionPsrId" :types="'personal'"></finance>
				</van-tab>
				<van-tab title="过继关系" v-if="personalInfo.sex=='M'">
					<adpot :readonly="true" :p_id="actionPsrId" :family_name="family_name" :pedigree_num="pdg_num"></adpot>
				</van-tab>
				<van-tab title="过往信息" v-if="showPastTab">
					<pasted-info :readonly="true" :p_id="actionPsrId" :scsx="$parent.scsx"></pasted-info>
				</van-tab>
			</van-tabs>
		</van-popup>

		<van-calendar v-model:show="showQueryCalendar" @confirm="onConfirmCalendar" :min-date="minDate" :max-date="maxDate" :style="{'bottom':'50px'}" />
	</div>
</template>

<script>
	import { Search,DropdownMenu, DropdownItem, Calendar,List, Card, SwipeCell, ImagePreview } from 'vant';
	import {num2chinese } from "@/utils/common.js";
	import {lunarUtil} from "@/utils/lunar.js";

	import PersonalInfo from "@/components/Clans/PersonalInfo";
	import Education from "@/components/Clans/Education";
	import House from "@/components/Clans/House";
	import Vitae from "@/components/Clans/Vitae";
	import Adpot from "@/components/Clans/Adpot";
	import Finance from "@/components/Clans/Finance";
	import PastedInfo from "@/components/Clans/PastedInfo";

	export default {
		name: "PedigreeTree",
		components: {
			"van-search":Search,
			"van-dropdown-menu":DropdownMenu,
			"van-dropdown-item":DropdownItem,
			"van-calendar":Calendar,
			"van-list":List,
			"van-card":Card,
			"van-swipe-cell":SwipeCell,

			"personal-info":PersonalInfo,
			"edu":Education,
			"house":House,
			"vitae":Vitae,
			"adpot":Adpot,
			"finance":Finance,
			"pasted-info":PastedInfo
		},
		props:['keyword'],
		computed:{
			scsxCols:function(){
				let sc = [];
				let sx = [];
				let cols = [];
				let obj = null;
				for(var k in this.$parent.scsx){
					obj = this.$parent.scsx[k];
					sc.push(obj.sc);
					sx.push(obj.sx);
					obj['key'] = k;
					cols.push(obj);
				}
				return {sc:sc, sx:sx, cols:cols}
			}
		},
		data() {
			return {
				winH:300,
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id")+"token"),
				attach_url: this.Conf.serverPre,
				searchText:'',
				srchKeyWord:'',
				pdg_id:null,
				pdg_num:null,
				pdg_name:'',
				family_name:'',
				personal_id:null,

				coverImg:{'M':require('../../assets/img/clans/boy.png'),'F':require('../../assets/img/clans/gril.png')},
			
				srchType:'personal',
				curSrchType:'personal',
				srchTypeItems:{
					'personal':{ title: '人员', placeholder:'名字、曾用名、字号', dateTitle:'出生',params:{chkZodias:[],dateStr:'',dateBeg:'',dateEnd:'',inLaws:-1,health:0}},
					'education':{ title: '教育', placeholder:'学校、学历、专业', dateTitle:'时间',params:{dateStr:'',dateBeg:'',dateEnd:''}},
					'house':{ title: '置业', placeholder:'住宅名、坐向、地址', dateTitle:'置建',params:{dateStr:'',dateBeg:'',dateEnd:''}},
					'vitae':{ title: '履历', placeholder:'履历内容', dateTitle:'时间',params:{dateStr:'',dateBeg:'',dateEnd:''}}
				},
				srchParamsPsr:{chkZodias:[],dateStr:'',dateBeg:'',dateEnd:''},
				showQueryCalendar:false,
				queryCalendarType:'',
				minDate:new Date(1900, 0, 1),
				maxDate:new Date(),
				inLaws:'0',
				health:'0',

				actionPsrId:-1,
				showPersonalPopup:false,
				personalActive:0,
				showPastTab:false,

				pedigreeInfo:{},
				imgList:[],
				infoAuth:{},
				dataList:[],
				houseTypes:['自建','购买','合建','合购'],

				page:0,
				pageSize:0,
				total:0,
				loading: false,
				finished: false,
				refreshing: false

			};
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.winH = `${document.documentElement.clientHeight}`;
			window.onresize = function temp() {
				this.winH = `${document.documentElement.clientHeight}`;
			};
			
		},
		methods: {
			onClickLeft() {
				this.$router.push(this.pdg_id?('/Clans/Chart/'+this.pdg_id):'/Clans');
			},
			getStateConfigs(){
				const confs = this.$store.state.common.configs;
				if(confs){
					if(confs.attach_url){
						this.attach_url = confs.attach_url.values;
					}
				}else{
					setTimeout(() => {
						this.getStateConfigs();
					},1000);
				}
			},
			chkLogined(msg){
				if(!(this.u_id && this.token)){
					this.$dialog
					.confirm({
						title: "温馨提醒",
						message: msg||"登录后即可操作",
						showCancelButton:true,
						confirmButtonText:'马上登录',
						cancelButtonText:'再看看'
					})
					.then(() => {
						this.$router.push({ path: "/Login" });
						return false;
					})
					.catch(error => {
						return false;
					});
					return false;
				}
				return true;
			},
			showCanlendar2Query(t){
				this.queryCalendarType = t;
				this.showQueryCalendar = true;
			},
			onConfirmCalendar(d){
				this.srchTypeItems[this.srchType].params[this.queryCalendarType] =  `${d.getFullYear()}-${(d.getMonth()<9)?('0'+(d.getMonth()+1)):(d.getMonth())}-${d.getDate()<10?('0'+d.getDate()):d.getDate()}`;
				this.showQueryCalendar = false;
			},
			getDataList(){
				if (this.finished) {
					return false;
				}
				this.loading = true;
				setTimeout(() => {
					if (this.refreshing) {
						this.dataList = [];
						this.refreshing = false;
					}
					this.page = this.page+1;
					if(this.srchType == 'personal'){
						this.srchTypeItems[this.srchType].params.inLaws = this.inLaws;
						this.srchTypeItems[this.srchType].params.health = this.health;
					}
					var params = {
						u_id:this.u_id,
						token:this.token,
						pdg_id:this.pdg_id,
						pdg_num:this.pdg_num,
						personal_id:this.personal_id,
						types:this.srchType,
						cons:this.srchTypeItems[this.srchType].params
					};
					params.page = this.page;
					params.cons['keyword'] = this.searchText;

					this.srchKeyWord = this.searchText;
					let that = this;
					var url = this.Conf.serverUrl + "clans/search" + "?num="+Math.random();
					this.$axios
					.post(url, this.$qs.stringify(params))
					.then(response => {
						this.loading = false;
						if(response.data.code == 40001){
							this.$toast.fail(response.data.msg);
						}else{
							if (response.data.page == 1) {
								this.pageSize = response.data.pageSize;
								this.total = response.data.total;
								this.dataList = response.data.datas;
								this.curSrchType = response.data.types;
							}else{
								this.dataList = this.dataList.concat(response.data.datas);
							}
							if(this.page*this.pageSize >= this.total){
								this.finished = true;
							}
						}
					})
					.catch(error => {});

				}, 1000);
			},
			onRefresh() {
				this.finished = false;
				this.page = 0;
				this.getDataList();
			},
			onSearch(){
				this.onRefresh()
			},
			previewImg(img){
				var imgarr = [img.indexOf('http')==-1?(this.attach_url+img):img];
				ImagePreview({
					images: imgarr,
					showIndex:false,
					showIndicators:true
				});
			},
			getOrderStr(orders, sex){
				if(orders&&orders>0){
					if(sex == "M"){
						return ((orders==1)?"長子":(orders==2?'次子':(num2chinese(orders)+"子")))
					}
					if(sex == "F"){
						return ((orders==1)?"長女":(orders==2?'次女':(num2chinese(orders)+"女")))
					}
				}
				return '';
			},
			getDateStr(r){
				let rst = '';
				let cont = this.lunarObj.date2lunar(r.birthdate, r.birthday, r.hours?this.$parent.scsx[r.hours].sc:'', r.calendar, r.leep_month);
				if(r.past_id){
					let cemetery = r.cemetery;
					let pcont = this.lunarObj.date2lunar(r.pastdate, r.pastday, r.past_hours, r.past_calendar, r.past_leep_month);
					if(cont == "" && pcont == ""){
						rst = "生卒失考";
					}else if(cont != "" && pcont != ""){
						rst = "生於"+cont;
						rst += "，卒於"+pcont;
					}else{
						rst = (cont==""?"生辰未详":"生於"+cont)+"&nbsp;";
						rst += (pcont==""?"卒失考":"卒於"+pcont);
					}
				}else{
					rst = (cont==""?"生辰未详":"生於"+cont)+"&nbsp;";
				}
				return rst;
			},
			getZodiacStr(z,day){
				if(z) return z;
				if(day){
					return this.scsxCols.sx[((parseInt((day.split(" ")[0].split("-"))[0]) - 1900) % 12 + 12) % 12];
				}
				return '';
			},
			onViewPersonal(id,sex,pt_id){
				this.actionPsrId = id;
				this.personalInfo = {id: this.actionPsrId,sex:sex};
				this.showPastTab = pt_id?true:false;
				this.showPersonalPopup = true;
			}
		},
		created() {
			this.$parent.code = "search";
			this.searchText = this.keyword;
			this.pdg_id = this.$route.query.p_id;
			this.pdg_num = this.$route.query.p_num;
			this.pdg_name = this.$route.query.p_name;
			this.family_name = this.$route.query.family_name;
			this.personal_id = this.$route.query.personal_id;
			if(!this.pdg_name){
				this.$router.push(this.pdg_id?('/Clans/Chart/'+this.pdg_id):'/Clans')
			}
			this.$parent.title = this.pdg_name;
			this.getStateConfigs();
			
			this.lunarObj = new lunarUtil();

		}
	};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Clans/PedigreeSearch.vue